import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-cart-without-stock',
  templateUrl: './cart-without-stock.page.html',
  styleUrls: ['./cart-without-stock.page.scss'],
})
export class CartWithoutStockPage {

  @Input() modalData: { title: string, content: string, button: string } = { title: '', content: '', button: '' };

  constructor(private modalCtrl: ModalController) { }

  public onClose() {
    this.modalCtrl.dismiss(true);
  }

}
